import axios from 'axios'

export class DiscoveryResponse {
  endpoints: DiscoveryEndpoint[] = []
  features: DiscoveryFeature[] = []
  branding: DiscoveryBranding = {} as DiscoveryBranding
  googleApiKey: string = ''
  identitySettings: DiscoveryIdentitySettings = {} as DiscoveryIdentitySettings
  dropBoxAPIKey: string = ''
  dataGridConfigurations: DiscoverDataGridConfiguration[] = []
}

export interface DiscoveryIdentitySettings {
  identityUrl: string
  clientId: string
}

export interface DiscoveryEndpoint {
  name: string
  url: string
  additionalInfo: DiscoveryEndpointAdditionalInfo[]
}

export interface DiscoveryEndpointAdditionalInfo {
  key: string
  value: string
}

export interface DiscoveryFeature {
  componentName: string
  defaultPath: string
  description: string
  materialDesignIconName: string
  name: string
  ordinal: number
  permission: string
  tenantFeatureOverride: DiscoveryTenantFeatureOverride
  uniqueId: string
}

export interface DiscoveryTenantFeatureOverride {
  url: string
}

export interface DiscoveryBranding {
  companyName: string
  language: any[]
  theme: string
  locale: string
  tenantAssets: DiscoveryBrandingAsset[]
}

export interface DiscoveryBrandingAsset {
  fileName: string
  path: string
}

export interface DiscoverDataGridConfiguration {
  id: string
  tenantFeatureId: string
  key: string
}

export class Discovery {
  getDiscovery() {
    return new Promise<DiscoveryResponse>((resolve, reject) => {
      axios
        .get(import.meta.env.VITE_HOST_URL + 'api/discovery', {
          headers: {
            'Cache-Control': 'no-cache',
            'content-type': 'application/vnd.api+json'
          }
        })
        .then((result) => {
          resolve(result.data)
        })
        .catch(() => {
          reject()
        })
    })
  }
}

export default new Discovery()
